import {StyledCommandMenuItem, StyledCommandMenuList} from '@/components/commons/global-search/style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {Text} from '@/components/ui/text/Text'
import {formatDate} from '@/dayjs'
import {usePermissions} from '@/features/auth/store/store'
import {PatientSmall} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {toast} from '@/utilities/toast/toast'
import {useNavigate} from 'react-router-dom'

export const GlobalSearchList = ({patients}: {patients: PatientSmall[]}) => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const permissions = usePermissions()

    const getServiceTypeLabel = (serviceType: string) => {
        switch (serviceType) {
            case 'evolutionary_age':
                return t('commons:evolutionary_age')
            case 'adults':
                return t('commons:adults')
            default:
                return serviceType
        }
    }

    const handleClickPatient = (patient: PatientSmall) => {
        if (permissions?.patients.read) {
            navigate(`/patients/${patient.id}/information`)
        } else {
            toast.error(t('errors:no_permission_page'))
        }
    }

    return (
        <StyledCommandMenuList>
            <ScrollArea scrollbar={<Scrollbar />} style={{height: '100%'}}>
                {patients.length > 0 ? (
                    patients.map((patient, index) => (
                        <StyledCommandMenuItem
                            key={index}
                            value={patient.id}
                            onClick={() => handleClickPatient(patient)}
                        >
                            <Flexbox align="center" gap={2}>
                                <Text render="span" size="textMd" palette="neutral" shade="950" weight="400">
                                    {patient.fullName}
                                </Text>
                                <Text render="span" size="textSm" palette="neutral" shade="500">
                                    {getServiceTypeLabel(patient.serviceType)}
                                </Text>
                            </Flexbox>
                            <Text render="span" size="textSm" palette="neutral" shade="500">
                                {t('global_search:born_on', {
                                    date: formatDate(patient.birthDate, 'DD/MM/YYYY')
                                })}
                            </Text>
                        </StyledCommandMenuItem>
                    ))
                ) : (
                    <Text size="textSm" palette="neutral" shade="500" weight="400" style={{padding: '0 16px'}}>
                        {t('commons:no_results')}
                    </Text>
                )}
            </ScrollArea>
        </StyledCommandMenuList>
    )
}
